<template>
  <v-dialog
    ref="alertContainer"
    content-class="alert-container"
    v-model="openState">

    <div>
        <template v-if="contentComponent">
        <component :is="contentComponent"/>
      </template>
    </div>

  </v-dialog>
</template>

<script>
import { loadComponent } from '@/helpers/asyncLoaders'
import { mapState, mapActions } from 'vuex'

import {
  VUEX_ALERT_DIALOG_HIDE
} from '@/store/constants/ui/alertDialog'

export default {
  name: 'alert-dialog--container',

  data: () => ({
    contentComponent: null
  }),

  computed: {
    ...mapState({
      content: state => state.alertDialog.content
    }),

    openState: {
      get () { return this.$store.state.alertDialog.openState },
      set () { this.closeAlertDialog() }
    }
  },

  created () {
    this.loadContent()
  },

  methods: {
    ...mapActions({
      closeAlertDialog: VUEX_ALERT_DIALOG_HIDE
    }),

    loadContent () {
      this.contentComponent = (this.content) ? loadComponent(this.content) : null
    }
  },

  watch: {
    content: {
      handler () {
        this.loadContent()
      }
    }
  }
}
</script>

<style lang="scss">
  .v-dialog.alert-container {
    width: auto;
  }
</style>
